export const UPDATE_INVOICE_DATA = 'UPDATE_INVOICE_DATA'
export const CLEAR_INVOICE_DATA = 'CLEAR_INVOICE_DATA'
